"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerRequestDTOToJSON = exports.CustomerRequestDTOFromJSONTyped = exports.CustomerRequestDTOFromJSON = exports.instanceOfCustomerRequestDTO = void 0;
const CustomerRequestActionsDTO_1 = require("./CustomerRequestActionsDTO");
const CustomerRequestFieldValueDTO_1 = require("./CustomerRequestFieldValueDTO");
const CustomerRequestLinkDTO_1 = require("./CustomerRequestLinkDTO");
const CustomerRequestStatusDTO_1 = require("./CustomerRequestStatusDTO");
const DateDTO_1 = require("./DateDTO");
const PagedDTOAttachmentDTO_1 = require("./PagedDTOAttachmentDTO");
const PagedDTOCommentDTO_1 = require("./PagedDTOCommentDTO");
const PagedDTOCustomerRequestStatusDTO_1 = require("./PagedDTOCustomerRequestStatusDTO");
const PagedDTOSlaInformationDTO_1 = require("./PagedDTOSlaInformationDTO");
const PagedDTOUserDTO_1 = require("./PagedDTOUserDTO");
const RequestTypeDTO_1 = require("./RequestTypeDTO");
const ServiceDeskDTO_1 = require("./ServiceDeskDTO");
const UserDTO_1 = require("./UserDTO");
/**
 * Check if a given object implements the CustomerRequestDTO interface.
 */
function instanceOfCustomerRequestDTO(value) {
    return true;
}
exports.instanceOfCustomerRequestDTO = instanceOfCustomerRequestDTO;
function CustomerRequestDTOFromJSON(json) {
    return CustomerRequestDTOFromJSONTyped(json, false);
}
exports.CustomerRequestDTOFromJSON = CustomerRequestDTOFromJSON;
function CustomerRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'expands': json['_expands'] == null ? undefined : json['_expands'],
        'links': json['_links'] == null ? undefined : (0, CustomerRequestLinkDTO_1.CustomerRequestLinkDTOFromJSON)(json['_links']),
        'actions': json['actions'] == null ? undefined : (0, CustomerRequestActionsDTO_1.CustomerRequestActionsDTOFromJSON)(json['actions']),
        'attachments': json['attachments'] == null ? undefined : (0, PagedDTOAttachmentDTO_1.PagedDTOAttachmentDTOFromJSON)(json['attachments']),
        'comments': json['comments'] == null ? undefined : (0, PagedDTOCommentDTO_1.PagedDTOCommentDTOFromJSON)(json['comments']),
        'createdDate': json['createdDate'] == null ? undefined : (0, DateDTO_1.DateDTOFromJSON)(json['createdDate']),
        'currentStatus': json['currentStatus'] == null ? undefined : (0, CustomerRequestStatusDTO_1.CustomerRequestStatusDTOFromJSON)(json['currentStatus']),
        'issueId': json['issueId'] == null ? undefined : json['issueId'],
        'issueKey': json['issueKey'] == null ? undefined : json['issueKey'],
        'participants': json['participants'] == null ? undefined : (0, PagedDTOUserDTO_1.PagedDTOUserDTOFromJSON)(json['participants']),
        'reporter': json['reporter'] == null ? undefined : (0, UserDTO_1.UserDTOFromJSON)(json['reporter']),
        'requestFieldValues': json['requestFieldValues'] == null ? undefined : (json['requestFieldValues'].map(CustomerRequestFieldValueDTO_1.CustomerRequestFieldValueDTOFromJSON)),
        'requestType': json['requestType'] == null ? undefined : (0, RequestTypeDTO_1.RequestTypeDTOFromJSON)(json['requestType']),
        'requestTypeId': json['requestTypeId'] == null ? undefined : json['requestTypeId'],
        'serviceDesk': json['serviceDesk'] == null ? undefined : (0, ServiceDeskDTO_1.ServiceDeskDTOFromJSON)(json['serviceDesk']),
        'serviceDeskId': json['serviceDeskId'] == null ? undefined : json['serviceDeskId'],
        'sla': json['sla'] == null ? undefined : (0, PagedDTOSlaInformationDTO_1.PagedDTOSlaInformationDTOFromJSON)(json['sla']),
        'status': json['status'] == null ? undefined : (0, PagedDTOCustomerRequestStatusDTO_1.PagedDTOCustomerRequestStatusDTOFromJSON)(json['status']),
    };
}
exports.CustomerRequestDTOFromJSONTyped = CustomerRequestDTOFromJSONTyped;
function CustomerRequestDTOToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        '_expands': value['expands'],
        '_links': (0, CustomerRequestLinkDTO_1.CustomerRequestLinkDTOToJSON)(value['links']),
        'actions': (0, CustomerRequestActionsDTO_1.CustomerRequestActionsDTOToJSON)(value['actions']),
        'attachments': (0, PagedDTOAttachmentDTO_1.PagedDTOAttachmentDTOToJSON)(value['attachments']),
        'comments': (0, PagedDTOCommentDTO_1.PagedDTOCommentDTOToJSON)(value['comments']),
        'createdDate': (0, DateDTO_1.DateDTOToJSON)(value['createdDate']),
        'currentStatus': (0, CustomerRequestStatusDTO_1.CustomerRequestStatusDTOToJSON)(value['currentStatus']),
        'issueId': value['issueId'],
        'issueKey': value['issueKey'],
        'participants': (0, PagedDTOUserDTO_1.PagedDTOUserDTOToJSON)(value['participants']),
        'reporter': (0, UserDTO_1.UserDTOToJSON)(value['reporter']),
        'requestFieldValues': value['requestFieldValues'] == null ? undefined : (value['requestFieldValues'].map(CustomerRequestFieldValueDTO_1.CustomerRequestFieldValueDTOToJSON)),
        'requestType': (0, RequestTypeDTO_1.RequestTypeDTOToJSON)(value['requestType']),
        'requestTypeId': value['requestTypeId'],
        'serviceDesk': (0, ServiceDeskDTO_1.ServiceDeskDTOToJSON)(value['serviceDesk']),
        'serviceDeskId': value['serviceDeskId'],
        'sla': (0, PagedDTOSlaInformationDTO_1.PagedDTOSlaInformationDTOToJSON)(value['sla']),
        'status': (0, PagedDTOCustomerRequestStatusDTO_1.PagedDTOCustomerRequestStatusDTOToJSON)(value['status']),
    };
}
exports.CustomerRequestDTOToJSON = CustomerRequestDTOToJSON;
//# sourceMappingURL=CustomerRequestDTO.js.map